export const languagesList = [
  { code: 'en', name: 'English' },
  { code: 'sq', name: 'Albanian' }
] as const;

export type LanguageCode = typeof languagesList[number]["code"];

export const defaultLanguageCode: LanguageCode = 'en';

export type Language = {
  code: string,     
  name: string,
}
